<template>
  <router-view />
</template>

<script>
export default {
  data(){ 
    return{
    }   
  },
  components:{
  }
};
</script>
<style>
@import '/assets/css/font-awesome.min.css';
@import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
@import '/assets/css/style.css';
@import '/assets/css/responsive.css';
</style>
